<template>
  <div style="height: 100%">
    <v-card
      class="modern-stat-card"
      height="100%"
      v-on="clickable ? { click: clicked } : {}"
      :class="data.selected ? 'selected-card' : 'unselected-card'"
    >
      <div
        class="d-flex flex-column flex-lg-row align-center pa-3 pa-sm-5 pe-sm-1"
      >
        <div
          class="
            text-center text-lg-start
            flex-grow-1 flex-shrink-0
            order-1 order-lg-0
          "
        >
          <div class="stat-value">{{ data.value }}</div>
          <div class="stat-label">{{ data.text }}</div>
        </div>

        <div
          class="stat-icon-wrapper d-flex align-center justify-center order-0 order-lg-1 mb-2 mb-lg-0"
          :class="data.selected ? 'stat-icon-wrapper--selected' : ''"
        >
          <v-icon
            :color="data.selected ? 'white' : 'primary'"
            class="stat-icon"
            >{{ data.icon }}</v-icon
          >
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      clickable: false,
    };
  },
  props: {
    data: {
      type: Object,
    },
  },
  created() {
    if (this.$route.name === "Home" || this.$route.name === "Courses") {
      this.clickable = true;
    }
  },
  methods: {
    clicked() {
      this.$emit("onClick");
    },
  },
};
</script>

<style scoped>
.modern-stat-card {
  border-radius: 14px !important;
  transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
  cursor: pointer;
}
.unselected-card {
  background: #ffffff !important;
  border: 1px solid rgba(15, 23, 42, 0.06);
  box-shadow: 0 2px 10px 0 rgba(15, 23, 42, 0.04) !important;
  color: #1e293b !important;
}
.unselected-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 20px 0 rgba(37, 99, 235, 0.1) !important;
  border-color: rgba(37, 99, 235, 0.25);
}
.selected-card {
  background: linear-gradient(135deg, #2563eb, #1d4ed8) !important;
  color: white !important;
  box-shadow: 0 8px 22px rgba(37, 99, 235, 0.28) !important;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
.selected-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 26px rgba(37, 99, 235, 0.35) !important;
}
.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 4px;
}
.stat-label {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.8;
}
.stat-icon-wrapper {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  background-color: #eff6ff;
  flex-shrink: 0;
}
.stat-icon-wrapper--selected {
  background-color: rgba(255, 255, 255, 0.2);
}
.stat-icon {
  font-size: 22px !important;
}
</style>
